import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const ContactPage = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    projectType: '',
    budgetRange: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const formDataObj = new FormData();
  formDataObj.append("access_key", "30e1aeee-e812-42eb-aec4-c33cde77a061");

  formDataObj.append("name", formData.name);
  formDataObj.append("phone", formData.phone);
  formDataObj.append("email", formData.email);
  formDataObj.append("projectType", formData.projectType);
  formDataObj.append("budgetRange", formData.budgetRange);
  formDataObj.append("message", formData.message);

  const response = await fetch("https://api.web3forms.com/submit", {
    method: "POST",
    body: formDataObj
  });

  const result = await response.json();

  if (result.success) {
    toast({
      title: "Enquiry Submitted Successfully!",
      description: "We'll get back to you within 24 hours.",
    });

    setFormData({
      name: '',
      phone: '',
      email: '',
      projectType: '',
      budgetRange: '',
      message: ''
    });

  } else {
    toast({
      title: "Submission Failed",
      description: "Please try again later.",
    });
  }
};

  return (
    <div className="bg-[#F4EFE8] min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[40vh] lg:h-[50vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1602028915047-37269d1a73f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxtb2R1bGFyJTIwa2l0Y2hlbnxlbnwwfHx8fDE3NzEyMzgwNzN8MA&ixlib=rb-4.1.0&q=85"
            alt="Contact"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#111111]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 text-center">
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-white mb-6">
            Get in Touch
          </h1>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">
            Let's discuss your vision and create something extraordinary.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-16 lg:gap-20">
            {/* Contact Info */}
            <div>
              <h2 className="font-serif text-4xl lg:text-5xl text-[#111111] mb-6">
                Visit Our Showroom
              </h2>
              <p className="text-[#242424] text-lg leading-relaxed mb-12">
                Experience our craftsmanship firsthand. Visit our showroom in Jalandhar to explore materials, finishes, and completed displays.
              </p>

              <div className="space-y-8 mb-12">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#B89A4F]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <MapPin className="text-[#B89A4F]" size={24} />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-[#111111] mb-2">Address</h3>
                    <p className="text-[#242424]">
                      NorthFold Showroom<br />
                      Near Goyal Hyundai, Wadala Chownk, Nakodar Road,
                      Jalandhar, Punjab - 144003<br />
                      Punjab, India
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#B89A4F]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Phone className="text-[#B89A4F]" size={24} />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-[#111111] mb-2">Phone</h3>
                    <p className="text-[#242424]">+91 7888952279</p>
                    <p className="text-sm text-[#242424] mt-1">Mon - Sat: 10 AM - 7 PM</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#B89A4F]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Mail className="text-[#B89A4F]" size={24} />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-[#111111] mb-2">Email</h3>
                    <p className="text-[#242424]">Northfold7@gmail.com</p>
                    <p className="text-sm text-[#242424] mt-1">We'll respond within 24 hours</p>
                  </div>
                </div>
              </div>

              <div className="mt-10">
                <h3 className="text-lg font-semibold text-[#111111] mb-4">Our Location</h3>

                <div className="rounded-luxury overflow-hidden shadow-luxury">
                <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3409.4947635935237!2d75.5555394!3d31.290067699999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a5b518815cc7f%3A0xd1a1d0620a35e22d!2sNorthFold!5e0!3m2!1sen!2sin!4v1775225857608!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                className="w-full h-[250px] md:h-[300px]"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                ></iframe>
                </div>
            </div>

              <a
                href="https://www.google.com/maps?q=YOUR_LOCATION"
                target="_blank"
                className="inline-block mt-4 text-sm text-[#B89A4F] underline"
                >
              Get Directions →
                </a>

              <div className="bg-white p-8 shadow-luxury rounded-luxury">
                <h3 className="text-xl font-semibold text-[#111111] mb-4">Working Hours</h3>
                <div className="space-y-2 text-[#242424]">
                  <div className="flex justify-between">
                    <span>Monday - Friday</span>
                    <span className="font-medium">10:00 AM - 8:00 PM</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Saturday</span>
                    <span className="font-medium">10:00 AM - 7:00 PM</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Sunday</span>
                    <span className="font-medium text-[#B89A4F]">By Appointment</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <div className="bg-white p-8 lg:p-12 shadow-luxury rounded-luxury">
                <h2 className="font-serif text-3xl lg:text-4xl text-[#111111] mb-4">
                  Book Your Free Design Consultation
                </h2>
                <p className="text-[#242424] mb-8 leading-relaxed">
                  Share your requirements and our design experts will connect with you to discuss materials, layouts, and create a personalized solution for your space.
                </p>

                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-[#111111] mb-2">
                      Full Name *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-luxury focus:border-[#B89A4F] focus:outline-none focus:ring-1 focus:ring-[#B89A4F] transition-colors duration-300"
                      placeholder="Enter your full name"
                    />
                  </div>

                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-[#111111] mb-2">
                        Phone Number *
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        required
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-luxury focus:border-[#B89A4F] focus:outline-none focus:ring-1 focus:ring-[#B89A4F] transition-colors duration-300"
                        placeholder="+91 7888952279"
                      />
                    </div>

                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-[#111111] mb-2">
                        Email Address *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-luxury focus:border-[#B89A4F] focus:outline-none focus:ring-1 focus:ring-[#B89A4F] transition-colors duration-300"
                        placeholder="your@email.com"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="projectType" className="block text-sm font-medium text-[#111111] mb-2">
                      Project Type *
                    </label>
                    <select
                      id="projectType"
                      name="projectType"
                      required
                      value={formData.projectType}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-luxury focus:border-[#B89A4F] focus:outline-none focus:ring-1 focus:ring-[#B89A4F] transition-colors duration-300"
                    >
                      <option value="">Select project type</option>
                      <option value="modular-kitchen">Modular Kitchen</option>
                      <option value="modular-kitchen">Classical Kitchen</option>
                      <option value="wardrobe">Wardrobe</option>
                      <option value="kitchen-wardrobe">Kitchen + Wardrobe</option>
                      <option value="storage">Storage Solutions</option>
                      <option value="full-interior">Full Interior Package</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="budgetRange" className="block text-sm font-medium text-[#111111] mb-2">
                      Budget Range *
                    </label>
                    <select
                      id="budgetRange"
                      name="budgetRange"
                      required
                      value={formData.budgetRange}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-luxury focus:border-[#B89A4F] focus:outline-none focus:ring-1 focus:ring-[#B89A4F] transition-colors duration-300"
                    >
                      <option value="">Select budget range</option>
                      <option value="under-5">Under ₹5 Lakhs</option>
                      <option value="5-10">₹5-10 Lakhs</option>
                      <option value="10-20">₹10-20 Lakhs</option>
                      <option value="20-plus">₹20 Lakhs+</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-[#111111] mb-2">
                      Additional Details
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      rows="5"
                      value={formData.message}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-luxury focus:border-[#B89A4F] focus:outline-none focus:ring-1 focus:ring-[#B89A4F] transition-colors duration-300"
                      placeholder="Tell us about your requirements, timeline, or any specific preferences..."
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="w-full bg-[#111111] text-[#B89A4F] px-8 py-4 text-sm tracking-widest uppercase hover:bg-[#B89A4F] hover:text-[#111111] transition-all duration-300 flex items-center justify-center space-x-3 rounded-luxury"
                  >
                    <span>Submit Enquiry</span>
                    <Send size={18} />
                  </button>

                  <p className="text-xs text-[#242424] text-center">
                    By submitting this form, you agree to be contacted by NorthFold regarding your enquiry.
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
